// Import routes
import ROUTES, { RenderRoutes } from './navigation/routes';
import { RouteChangeLoader } from './components/RouteChangeLoader';

const App = () => {
  return (
    <RouteChangeLoader>
      <RenderRoutes routes={ROUTES} />
    </RouteChangeLoader>
  );
};

export default App;
